import { useEffect, useCallback, useMemo, useState } from 'react';
import { useRouteMatch, useParams } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import { getAllPossibleConnections } from '../ConnectedContentService';

function useAllConnections(isMounted) {
  const [allConnections, setAllConnections] = useState(null);
  const [error, setError] = useState(null);
  const { url } = useRouteMatch();
  const { projectId } = useParams();

  const contentTypes = useMemo(() => {
    if (url.includes('key-focus-areas')) {
      return ['analyses'];
    }
    return ['analyses', 'hypotheses'];
  }, [url]);

  const processConnectedContent = useCallback(
    (connectedContent) => {
      const editedConnections = cloneDeep(connectedContent);
      const keysToRemove = Object.keys(editedConnections).filter(
        (key) => contentTypes.indexOf(key) < 0
      );
      keysToRemove.forEach((key) => {
        delete editedConnections[key];
      });
      return editedConnections;
    },
    [contentTypes]
  );

  useEffect(() => {
    const fetchAllPossibleConnections = async () => {
      try {
        const fetchedConnections = await getAllPossibleConnections(projectId);
        const processedConnections =
          processConnectedContent(fetchedConnections);
        setAllConnections(processedConnections);
      } catch (e) {
        setError(e);
      }
    };
    if (isMounted && !allConnections) {
      fetchAllPossibleConnections();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted]);

  return { allConnections, error };
}

export default useAllConnections;
